/*
 *
 * election constants
 *
 */
export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const GET_PROVINCE_LIST_REQUESTED = "election/GET_PROVINCE_LIST_REQUESTED";
export const GET_PROVINCE_LIST_SUCCESS = "election/GET_PROVINCE_LIST_SUCCESS";
export const GET_PROVINCE_LIST_FAILED = "election/GET_PROVINCE_LIST_FAILED";

export const GET_COUNTY_LIST_REQUESTED = "election/GET_COUNTY_LIST_REQUESTED";
export const GET_COUNTY_LIST_SUCCESS = "election/GET_COUNTY_LIST_SUCCESS";
export const GET_COUNTY_LIST_FAILED = "election/GET_COUNTY_LIST_FAILED";

export const GET_ELECTION_REQUESTED = "election/GET_ELECTION_REQUESTED";
export const GET_ELECTION_SUCCESS = "election/GET_ELECTION_SUCCESS";
export const GET_ELECTION_FAILED = "election/GET_ELECTION_FAILED";

export const GET_CAMP_LIST_REQUESTED = "election/GET_CAMP_LIST_REQUESTED";
export const GET_CAMP_LIST_SUCCESS = "election/GET_CAMP_LIST_SUCCESS";
export const GET_CAMP_LIST_FAILED = "election/GET_CAMP_LIST_FAILED";

export const GET_MANAGEMENT_LIST_REQUESTED = "election/GET_MANAGEMENT_LIST_REQUESTED";
export const GET_MANAGEMENT_LIST_SUCCESS = "election/GET_MANAGEMENT_LIST_SUCCESS";
export const GET_MANAGEMENT_LIST_FAILED = "election/GET_MANAGEMENT_LIST_FAILED";

export const MANAGE_VOTING_REQUESTED = "election/MANAGE_VOTING_REQUESTED";
export const MANAGE_VOTING_SUCCESS = "election/MANAGE_VOTING_SUCCESS";
export const MANAGE_VOTING_FAILED = "election/MANAGE_VOTING_FAILED";

export const GET_ELECTION_QUOTA_REQUESTED = "election/GET_ELECTION_QUOTA_REQUESTED";
export const GET_ELECTION_QUOTA_SUCCESS = "election/GET_ELECTION_QUOTA_SUCCESS";
export const GET_ELECTION_QUOTA_FAILED = "election/GET_ELECTION_QUOTA_FAILED";

export const SET_CANDIDATE_STATUS_REQUESTED = "election/SET_CANDIDATE_STATUS_REQUESTED";
export const SET_CANDIDATE_STATUS_SUCCESS = "election/SET_CANDIDATE_STATUS_SUCCESS";
export const SET_CANDIDATE_STATUS_FAILED = "election/SET_CANDIDATE_STATS_FAILED";

export const SET_VALIDATE_STATUS_REQUESTED = "election/SET_VALIDATE_STATUS_REQUESTED";
export const SET_VALIDATE_STATUS_SUCCESS = "election/SET_VALIDATE_STATUS_SUCCESS";
export const SET_VALIDATE_STATUS_FAILED = "election/SET_VALIDATE_STATS_FAILED";

export const SET_CANDIDATE_DIALOG_OPEN = "election/SET_CANDIDATE_DIALOG_OPEN";
export const SET_CANCEL_CANDIDATE_DIALOG_OPEN = "election/SET_CANCEL_CANDIDATE_DIALOG_OPEN";
export const SET_VALIDATE_DIALOG_OPEN = "election/SET_VALIDATE_DIALOG_OPEN";

//voting
export const SET_VOTING_DIALOG_OPEN = "election/SET_VOTING_DIALOG_OPEN";

export const SEND_CONFIRM_SMS_REQUESTED = "election/SEND_CONFIRM_SMS_REQUESTED";
export const SEND_CONFIRM_SMS_SUCCESS = "election/SEND_CONFIRM_SMS_SUCCESS";
export const SEND_CONFIRM_SMS_FAILED = "election/SEND_CONFIRM_SMS_FAILED";

export const SEND_VOTE_REQUESTED = "election/SEND_VOTE_REQUESTED";
export const SEND_VOTE_SUCCESS = "election/SEND_VOTE_SUCCESS";
export const SEND_VOTE_FAILED = "election/SEND_VOTE_FAILED";

//appoint
export const SET_APPOINT_DIALOG_OPEN = "election/SET_APPOINT_DIALOG_OPEN";

export const SEND_APPOINT_REQUESTED = "election/SEND_APPOINT_REQUESTED";
export const SEND_APPOINT_SUCCESS = "election/SEND_APPOINT_SUCCESS";
export const SEND_APPOINT_FAILED = "election/SEND_APPOINT_FAILED";

//managementElections
export const SET_MANAGEMENT_ELECTION_DIALOG_OPEN = "election/SET_MANAGEMENT_ELECTION_DIALOG_OPEN";
